// Domain
import { CurrentPlanEntity } from '../entities/current-plan-entity';
import { CurrentAmountEntity } from '../entities/current-amount-entity';
import { RetirementAgeEntity } from '../entities/retirement-age-entity';
import { DefineByEntity } from '../entities/define-by-entity';

export default class State {
  current_plan: CurrentPlanEntity = {
    target_amount: '',
    current_amount: '',
    monthly_required_amount: '',
    retirement_age: '',
    monthly_pension: '',
    associated_product_id: '',
    associated_product_interest_rate: 0,
    retirement_fund_id: '',
    calculate_inflation: false,
  }

  current_amount: CurrentAmountEntity = {
    additional_amount: 0,
    there_is_more_savings: '',
    amount_added: 0,
  }

  retirement_age: RetirementAgeEntity = {
    retirement_age: 0,
    current_age: 0,
    retirement: 0,
    pension: 0,
    lifetime_expected: 85,
  }

  define_by: DefineByEntity = {
    is_defined_by_contribution: false,
    defined_by: 'pension',
    monthly_desired_pension: '0.00',
    monthly_pension_adjusted: 0,
    calculated_pension: 0,
    contribution: '0.00',
    monthly_required_amount: 0,
    accumulated_amount: 0,
    legacy_amount: 0,
    calculate_inflation: false,
    initial_investment_date: '',
    final_investment_date: '',
    with_inflation: {
      monthly_pension: 0,
      monthly_required_amount: 0,
      accumulated_amount: 0,
      pension_desired_in_future: 0,
    },
    without_inflation: {
      monthly_pension: 0,
      monthly_required_amount: 0,
      accumulated_amount: 0,
      pension_desired_in_future: 0,
    },
    percentage_decrease: 0,
    modify_recurring_contribution_automatically: false,
    maximum_amount_exceeded: false,
    go_back_to_one_contribution: false,
  }
}
